import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploadfileComponent } from './uploadfile.component';
import { FormsModule } from '@angular/forms';



@NgModule({
  declarations: [
    UploadfileComponent
  ],
  exports:[
    UploadfileComponent
  ],
  imports: [
    CommonModule,
    FormsModule
  ]
})
export class UploadfileModule { }
